import React, {
  useRef,
  useState,
  useEffect,  
} from "react";
import FontBox from "components/FontBox";
import {
  Link,  
  useNavigate,  
} from "react-router-dom";

import {
  Container,
  FontContainer,  
  CounterNav,
  Item,  
  TopArea,  
  SearchBox,  
  Keyword,
  ComboWrapper,
  BtnClearKeyword,
  SearchBtn,
  ToolContainer,
} from "./style";



import Loader from "components/Loading";

import bottomButton from "resources/bottomButton.png";
import topButton from "resources/topButton.png";

import { useFontCartList, useFontCartUpdate } from "contexts/font.Context";

import Select, { components, PlaceholderProps } from "react-select";

import { Slider, Row, Col } from "antd";

const HomePresenter = ({ familyname, data, loading, sortType, changeSort }) => {
  const containerRef = useRef();
  const tryInputRef = useRef();


  const sum = data
    .map((item) => item.cnt)
    .reduce((prev, curr) => prev + curr, 0);

  //스크롤 위치 가져오기


  let datas = useFontCartList();

  console.log(datas);


  const goToBottom = () => {
    // let scrollHeight = document.documentElement.scrollHeight;
    let currentScroll = window.pageYOffset + 350;


    if (position.percent > 90) {
      window.scrollTo(0, document.body.scrollHeight);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: currentScroll, behavior: "smooth" });
    }
  };

  // 키워드로 다시 데이터 가져오기
  const searchKeyword = (event) => {
    const {
      target: { value },
    } = event;
    setKeyword(value);
  };

  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [sampleText, setSampleText] = useState("");

  let sample_text = [
    {
      label: "서체명",
      value: "서체명",
    },
    {
      label: "문장",
      value:
        "푸른 산과 바다가 펼쳐진 곳을 마음에 담고 싶은 여유를 간직하고 싶다.",
    },
    {
      label: "알파벳",
      value: "abcdefghijklmnopqrsLMNOPQRSTUVWXYZ",
    },
    {
      label: "숫자,특수문자",
      value: "1234567890!@#$%^&*()!‘’“” ()[]◆·¨ℓАБВабв▲",
    },
    {
      label: "커스텀",
      value: "",
    },
  ];

  const [selectOption, setSelectOption] = useState(sample_text);

  //샘플텍스트 초기값
  const sample_default = sample_text[0].value;
  const [sample, setSample] = useState(sample_default);

  //샘플 사이즈
  const [sampleSize, setSampleSize] = useState(38);


  const searchFontList = (event) => {
    event.preventDefault();
    navigate(`/search/${keyword}`);
  };

  const clearKeyword = (event) => {
    setKeyword("");
  };

  //샘플 텍스트 변경
  const selectFamily = (event) => {
    setSample(event.value);
  };

  // 커스텀 입력값
  const InputChange = (data) => {
    // setSample(data);

    if (data !== "") {
      setSampleText(data);
      setSample(sampleText); // 커스텀 입력어
      // console.log(sampleText);
    }

    Object.keys(selectOption).forEach((key) => {
      //console.log(sample_text[key].label === "커스텀" ? sampleText : "");
      if (selectOption[key].label === "커스텀" && sampleText !== "") {
        selectOption[key].value = sampleText;
      }
    });

    setSelectOption(selectOption);
    // console.log(selectOption);
  };

  const styles = {
    control: (base) => ({
      ...base,
      fontFamily: "HYGothicL",
      fontSize: 14,
    }),
    menu: (base) => ({
      ...base,
      fontFamily: "HYGothicL",
      fontSize: 16,
    }),
  };

  const sortStyles = {
    control: (base) => ({
      ...base,
      border: 0,
      boxshadow: "none",

      fontFamily: "HYGothicL",
      fontSize: 14,
    }),
    menu: (base) => ({
      ...base,
      fontFamily: "HYGothicL",
      fontSize: 14,
    }),
  };

  const placeholderText = sampleText
    ? sampleText
    : "적용해 볼 문장을 입력하세요";

  // 폰트 사이즈 적용
  const [inputValue, setInputValue] = useState(32);
  const onChange = (newValue) => {
    setInputValue(newValue);
  };
  const AfterChange = (newValue) => {
    setSampleSize(newValue);
  };

  const formatter = (value) => `${value}px`;

  let sortOption = [
    {
      label: "인기순",
      value: "popular",
    },
    // {
    //   label: "조회순",
    //   value: "view",
    // },
    {
      label: "최신순",
      value: "newest",
    },
    {
      label: "이름순",
      value: "name",
    },
  ];

  //change sort
  const onChangeSort = (sort) => {


    if (sort.value === "newest") {
      changeSort({ ...sort, col: "made_date" });
    } else if (sort.value === "name") {
      changeSort({ ...sort, col: "familyname" });
    } else if (sort.value === "popular") {
      changeSort({ ...sort, col: "popular_rank" });
    } else {
      changeSort({ ...sort, col: "view_count" });
    }
  };


  const [position, setPosition] = useState({ scroll: 0, percent: 0 });
  const [buttonSrc, setButtonSrc] = useState(bottomButton)

  function onScroll() {

    const scrollHeight = document.documentElement.scrollHeight;
    const currentPosition = window.scrollY;
    const scrollPercent = Math.round(((currentPosition + 500) / scrollHeight) * 100);

    setPosition({ scroll: currentPosition, percent: scrollPercent })
    //setPosition(Math.round(currentPosition / scrollHeight) * 100);
    //console.log(position.scroll, position.percent, buttonSrc);

    position.percent > 90 ? setButtonSrc(topButton) : setButtonSrc(bottomButton);

  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  });



  return loading ? (
    <Loader />
  ) : (
    <Container>

      
      <ToolContainer>
        <SearchBox onSubmit={searchFontList}>
          <SearchBtn />
          <Keyword
            onChange={searchKeyword}
            value={keyword}
            placeholder="폰트명 검색"
          />

          {keyword !== "" ? (
            <BtnClearKeyword type="reset" value="X" onClick={clearKeyword} />
          ) : (
            ""
          )}
        </SearchBox>
        <ComboWrapper>
          <Select
            width="360px"
            menuColor="red"
            options={selectOption}
            onChange={selectFamily}
            onInputChange={InputChange}
            placeholder={placeholderText}
            noOptionsMessage={() => "적용해 볼 문장을 입력하세요."}
            styles={styles}
            ref={tryInputRef}
            autoFocus
            theme={(theme) => ({
              ...theme,
              borderRadius: 3,
              colors: {
                ...theme.colors,
                primary25: "#eeeeee",
                primary75: "#eeeeee",
                primary: "#87ccaf",
              },
            })}
          />
        </ComboWrapper>

        <div>
          <Row wrap={false} justify="center" align="middle">
            <Col flex="auto">
              <Slider
                defaultValue={32}
                // tooltipVisible={true}
                onChange={onChange}
                onAfterChange={AfterChange}
                tipFormatter={formatter}
                min={10}
                max={100}
              // trackStyle={{ backgroundColor: "red" }}
              // handleStyle={{ borderColor: "blue" }}
              />
            </Col>
            <Col flex="80px" style={{ padding: "1 px" }}>
              {inputValue}px
            </Col>
          </Row>
        </div>

        {/*    <RangeBox> <FontSizeValue style={sizeStyle}>{range.value}</FontSizeValue>
          <MinFontSize>A</MinFontSize>
          <FontSize type="range" {...range} readOnly />
          <MaxFontSize>A</MaxFontSize> </RangeBox>*/}
      </ToolContainer>

      <TopArea>
        <CounterNav className="no-print">
          <Item>
            {data?.length} 스타일 | {sum} 종
          </Item>
        </CounterNav>
        <p />
        <CounterNav className="no-print">
          <Item>
            <Link to="/cart">
              {/* <FontAwesomeIcon icon={faHeart} size="1x" /> |{" "} */}
              카트 |
            </Link>
          </Item>

          {/* <Item onClick={changeOrderByDate} select={orderDate} className="link">
            | 최신순
          </Item> */}

          <Select
            width="100px"
            options={sortOption}
            defaultValue={{ label: sortType?.label, value: sortType?.value }}
            components={{
              IndicatorSeparator: () => null,
              dropdownIndicator: (defaultStyles) => ({
                ...defaultStyles,
                "& svg": { display: "none" },
              }),
            }}
            isSearchable="false"
            onChange={onChangeSort}
            styles={sortStyles}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: "#eeeeee",
                primary75: "#eeeeee",
                primary: "#87ccaf",
              },
            })}
          />

          {/* <Item
            onClick={changeOrderByName}
            select={changeOrder}
            className="link"
          >
            <Link to="#"> | 이름순</Link>
          </Item> */}
        </CounterNav>
      </TopArea>

      <FontContainer ref={containerRef}>

        {data?.map((f, index) => {
          const text = (
            <FontBox
              key={f.idx}
              id={f.idx}
              type={f.types}
              webfont={f.webfontname}
              familyname={f.familyname}
              isNew={f.is_new}
              font={f}
              family_type={f.family_type}
              sampleText={sample}
              sampleSize={sampleSize}
            />
          );
          return text;
        })}

      </FontContainer>


      {/* <ButtomButton onClick={goToBottom} src={buttonSrc} className="no-print" /> */}

    </Container>
  );
};

export default HomePresenter;
